import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import './CVSectionModal.scss';

interface CVSectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  saveLabel?: string;
}

const CVSectionModal: React.FC<CVSectionModalProps> = ({
  isOpen,
  onClose,
  onSave,
  title,
  icon,
  children,
  saveLabel = 'Išsaugoti'
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="cv-modal-overlay" onMouseDown={onClose}>
      <div className="cv-modal-card" onMouseDown={(e) => e.stopPropagation()}>
        <div className="cv-modal-header">
          <div className="cv-modal-title">
            {icon && <span className="cv-modal-icon">{icon}</span>}
            <h3>{title}</h3>
          </div>
          <button className="cv-modal-close" onClick={onClose}><X size={20} /></button>
        </div>
        <div className="cv-modal-body">
          {children}
        </div>
        <div className="cv-modal-footer">
          <button className="cv-modal-save" onClick={onSave}>{saveLabel}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CVSectionModal;
